export const environment = {
  apim: {
    subscriptionKey: '3172db8d6d5a41caab98baf456e0938e'
  },
  auth: {
      applicationId: 'fd86992e-1e00-4732-bee5-d3bb5020b10d',
      authorityUrl: 'https://login.microsoftonline.com/fcb6fca8-f3c7-458b-9a80-211f5ce84b61/oauth2/v2.0/authorize',
      redirectUrl: 'http://localhost:4200/auth/callback'
  },
  mockAuth: {
    organizationIds: [] as string[],
    roles: [] as string[],
    sourceId: null
  },
  ofacService: {
      url: 'https://agv-apim-edt-c.azure-api.net/ofacservice-dev/api/',
    scope: 'api://e71202e6-6fa7-477d-a7ca-e41cb18d3036/Access',
    version: 'v3'
  },
  production: false,
  useMockAuth: false,
  useMockData: false
};

